import { render, staticRenderFns } from "./ArtistChartsTab.vue?vue&type=template&id=5f4084c8&"
import script from "./ArtistChartsTab.vue?vue&type=script&lang=js&"
export * from "./ArtistChartsTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports